import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "form-wrapper slide-up"
}
const _hoisted_3 = { class: "form-close" }
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              type: "button",
              class: "form-close-x",
              title: "Close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
            }, "×")
          ]),
          _createElementVNode("div", null, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { style: {"font-weight":"bold","margin-bottom":"15px"} }, "Select a role from a role sheet the standard user for this employee has access to. Check department and location settings if a role sheet is not showing here.", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sheetInput) = $event)),
              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setColOptions(null)))
            }, [
              _cache[5] || (_cache[5] = _createElementVNode("option", { value: null }, "Select Sheet", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allSheets, (s, i) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: s,
                  key: i
                }, _toDisplayString(s.Name), 9, _hoisted_4))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.sheetInput]
            ]),
            (_ctx.inputCols.length)
              ? _withDirectives((_openBlock(), _createElementBlock("select", {
                  key: 0,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.sheetColInput) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inputCols, (c, i) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: c.id,
                      key: i
                    }, _toDisplayString(c.text), 9, _hoisted_5))
                  }), 128))
                ], 512)), [
                  [_vModelSelect, _ctx.sheetColInput]
                ])
              : _createCommentVNode("", true),
            _createElementVNode("input", {
              style: {"margin-top":"15px"},
              class: _normalizeClass(_ctx.disableButton ? 'disable-button' : ''),
              type: "submit",
              value: "Submit",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.submit()))
            }, null, 2)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}